// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: h4sfzrx-5tAI
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import DeleteMilestone from "../../DeleteMilestone"; // plasmic-import: LwOIJjjJtjCn/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicMilestoneEntry.module.css"; // plasmic-import: h4sfzrx-5tAI/css

createPlasmicElementProxy;

export const PlasmicMilestoneEntry__VariantProps = new Array();

export const PlasmicMilestoneEntry__ArgProps = new Array("number");

const $$ = {};

function PlasmicMilestoneEntry__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"title18"}
        data-plasmic-override={overrides.title18}
        className={classNames(projectcss.all, sty.title18)}
      >
        {renderPlasmicSlot({
          defaultContents: "1.",
          value: args.number,
          className: classNames(sty.slotTargetNumber)
        })}
      </div>
      <div className={classNames(projectcss.all, sty.freeBox___3QAmD)}>
        <div
          data-plasmic-name={"title16"}
          data-plasmic-override={overrides.title16}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.title16
          )}
        >
          {hasVariant(globalVariants, "screen", "medium")
            ? "Milestone Title"
            : "Milestone Title"}
        </div>
        <div
          data-plasmic-name={"rectangle17"}
          data-plasmic-override={overrides.rectangle17}
          className={classNames(projectcss.all, sty.rectangle17)}
        >
          <input
            data-plasmic-name={"milestoneInput"}
            data-plasmic-override={overrides.milestoneInput}
            className={classNames(
              projectcss.all,
              projectcss.input,
              sty.milestoneInput
            )}
            placeholder={
              hasVariant(globalVariants, "screen", "medium") ? "" : ""
            }
            ref={ref => {
              $refs["milestoneInput"] = ref;
            }}
            size={1}
            type={"text"}
            value={""}
          />
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__xqIe)}>
        <div
          data-plasmic-name={"title22"}
          data-plasmic-override={overrides.title22}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.title22
          )}
        >
          {"Due Date (optional)\n"}
        </div>
        <div
          data-plasmic-name={"dateBox"}
          data-plasmic-override={overrides.dateBox}
          className={classNames(projectcss.all, sty.dateBox)}
        />
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__cd9S)}>
        <div
          data-plasmic-name={"title23"}
          data-plasmic-override={overrides.title23}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.title23
          )}
        >
          {"Deposit Amount"}
        </div>
        <div
          data-plasmic-name={"depositRectangle"}
          data-plasmic-override={overrides.depositRectangle}
          className={classNames(projectcss.all, sty.depositRectangle)}
        />
      </div>
      <DeleteMilestone
        data-plasmic-name={"deleteMilestone"}
        data-plasmic-override={overrides.deleteMilestone}
        className={classNames("__wab_instance", sty.deleteMilestone)}
      />
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "title18",
    "title16",
    "rectangle17",
    "milestoneInput",
    "title22",
    "dateBox",
    "title23",
    "depositRectangle",
    "deleteMilestone"
  ],

  title18: ["title18"],
  title16: ["title16"],
  rectangle17: ["rectangle17", "milestoneInput"],
  milestoneInput: ["milestoneInput"],
  title22: ["title22"],
  dateBox: ["dateBox"],
  title23: ["title23"],
  depositRectangle: ["depositRectangle"],
  deleteMilestone: ["deleteMilestone"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicMilestoneEntry__ArgProps,
          internalVariantPropNames: PlasmicMilestoneEntry__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicMilestoneEntry__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicMilestoneEntry";
  } else {
    func.displayName = `PlasmicMilestoneEntry.${nodeName}`;
  }
  return func;
}

export const PlasmicMilestoneEntry = Object.assign(
  // Top-level PlasmicMilestoneEntry renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    title18: makeNodeComponent("title18"),
    title16: makeNodeComponent("title16"),
    rectangle17: makeNodeComponent("rectangle17"),
    milestoneInput: makeNodeComponent("milestoneInput"),
    title22: makeNodeComponent("title22"),
    dateBox: makeNodeComponent("dateBox"),
    title23: makeNodeComponent("title23"),
    depositRectangle: makeNodeComponent("depositRectangle"),
    deleteMilestone: makeNodeComponent("deleteMilestone"),
    // Metadata about props expected for PlasmicMilestoneEntry
    internalVariantProps: PlasmicMilestoneEntry__VariantProps,
    internalArgProps: PlasmicMilestoneEntry__ArgProps
  }
);

export default PlasmicMilestoneEntry;
/* prettier-ignore-end */
